function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".arrowRight_svg__cls-1{fill:none;stroke:currentColor;stroke-width:2px}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "arrowRight_svg__Group_390",
  "data-name": "Group 390",
  transform: "translate(.707 .707)"
}, React.createElement("path", {
  id: "arrowRight_svg__Line_3",
  d: "M0 6l6-6",
  className: "arrowRight_svg__cls-1",
  "data-name": "Line 3"
}), React.createElement("path", {
  id: "arrowRight_svg__Line_1",
  d: "M0 0l6 6",
  className: "arrowRight_svg__cls-1",
  "data-name": "Line 1",
  transform: "translate(0 5)"
}));

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement("svg", _extends({
    width: 7.414,
    height: 12.414
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjQxNCIgaGVpZ2h0PSIxMi40MTQiIHZpZXdCb3g9IjAgMCA3LjQxNCAxMi40MTQiPgogICAgPGRlZnM+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTF7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLXdpZHRoOjJweH0KICAgICAgICA8L3N0eWxlPgogICAgPC9kZWZzPgogICAgPGcgaWQ9Ikdyb3VwXzM5MCIgZGF0YS1uYW1lPSJHcm91cCAzOTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC43MDcgLjcwNykiPgogICAgICAgIDxwYXRoIGlkPSJMaW5lXzMiIGQ9Ik0wIDZsNi02IiBjbGFzcz0iY2xzLTEiIGRhdGEtbmFtZT0iTGluZSAzIiAvPgogICAgICAgIDxwYXRoIGlkPSJMaW5lXzEiIGQ9Ik0wIDBsNiA2IiBjbGFzcz0iY2xzLTEiIGRhdGEtbmFtZT0iTGluZSAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDUpIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgArrowRight as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/arrowRight.svg
// module id = 331
// module chunks = 0